export var InstanceType;
(function (InstanceType) {
    InstanceType["SDK_KEY"] = "sdkKey";
    InstanceType["DATA_FILE"] = "datafile";
})(InstanceType || (InstanceType = {}));
//# sourceMappingURL=optimizely.types.js.map